import clsx from "clsx";
import { useState } from "react";
import InfoUserTab from "./components/info-user.tab.component";
import TransactionTab from "./components/transaction.tab.component";
import HistoryTab from "./components/history.tab.component";
import VasTab from "./components/vas.tab.component";
import BankAccountTab from "./components/bank-account.tab.component";
import GiveGiftTab from "./components/give-gift.tab.component";

enum Tab {
  INFO = 1,
  TRANSACTION = 2,
  HISTORY = 3,
  VAS = 4,
  BANK_ACCOUNT = 5,
  GIVE_GIFT = 6,
}

const UpdateUserPage = () => {
  const [tab, setTab] = useState(Tab.INFO);
  const changeTab = (tab: Tab) => {
    setTab(tab);
  };

  return (
    <div className="py-6 px-12">
      <div className="mt-6 rounded-xl bg-white py-6 px-5">
        <div className="flex">
          <div
            className={clsx(
              "w-[122px] h-[39px] text-[#ABAFB1] cursor-pointer rounded-t hover:bg-[#5570f1] hover:!text-white flex justify-center items-center border-b-4 border-solid border-transparent",
              {
                "!border-[#5570F1] !text-black": tab === Tab.INFO,
              }
            )}
            onClick={() => changeTab(Tab.INFO)}
          >
            Thông tin
          </div>
          <div
            className={clsx(
              "w-[122px] h-[39px] text-[#ABAFB1] cursor-pointer rounded-t hover:bg-[#5570f1] hover:!text-white flex justify-center items-center border-b-4 border-solid border-transparent",
              {
                "!border-[#5570F1] !text-black": tab === Tab.TRANSACTION,
              }
            )}
            onClick={() => changeTab(Tab.TRANSACTION)}
          >
            Giao dịch
          </div>
          <div
            className={clsx(
              "w-[122px] h-[39px] text-[#ABAFB1] cursor-pointer rounded-t hover:bg-[#5570f1] hover:!text-white flex justify-center items-center border-b-4 border-solid border-transparent",
              {
                "!border-[#5570F1] !text-black": tab === Tab.HISTORY,
              }
            )}
            onClick={() => changeTab(Tab.HISTORY)}
          >
            Hoạt động
          </div>
          <div
            className={clsx(
              "w-[122px] h-[39px] text-[#ABAFB1] cursor-pointer rounded-t hover:bg-[#5570f1] hover:!text-white flex justify-center items-center border-b-4 border-solid border-transparent",
              {
                "!border-[#5570F1] !text-black": tab === Tab.VAS,
              }
            )}
            onClick={() => changeTab(Tab.VAS)}
          >
            Vas
          </div>
          <div
            className={clsx(
              "w-[160px] h-[39px] text-[#ABAFB1] cursor-pointer rounded-t hover:bg-[#5570f1] hover:!text-white flex justify-center items-center border-b-4 border-solid border-transparent",
              {
                "!border-[#5570F1] !text-black": tab === Tab.BANK_ACCOUNT,
              }
            )}
            onClick={() => changeTab(Tab.BANK_ACCOUNT)}
          >
            Tài khoản ngân hàng
          </div>
          <div
            className={clsx(
              "w-[160px] h-[39px] text-[#ABAFB1] cursor-pointer rounded-t hover:bg-[#5570f1] hover:!text-white flex justify-center items-center border-b-4 border-solid border-transparent",
              {
                "!border-[#5570F1] !text-black": tab === Tab.GIVE_GIFT,
              }
            )}
            onClick={() => changeTab(Tab.GIVE_GIFT)}
          >
            Tặng quà
          </div>
        </div>
        <div className="mt-4">{tab === Tab.INFO && <InfoUserTab />}</div>
        <div className="mt-4">
          {tab === Tab.TRANSACTION && <TransactionTab />}
        </div>
        <div className="mt-4">{tab === Tab.HISTORY && <HistoryTab />}</div>
        <div className="mt-4">{tab === Tab.VAS && <VasTab />}</div>
        <div className="mt-4">
          {tab === Tab.BANK_ACCOUNT && <BankAccountTab />}
        </div>
        <div className="mt-4">{tab === Tab.GIVE_GIFT && <GiveGiftTab />}</div>
      </div>
    </div>
  );
};

export default UpdateUserPage;
